import { RecipeCard } from "@components/RecipeCard/RecipeCard";
import { CSSGrid } from "@jmc/solid-design-system/src/components/atoms/CSSGrid/CSSGrid";
import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import { Slider } from "@jmc/solid-design-system/src/components/molecules/Slider/Slider";
import { BreakPoint, useMediaQuery } from "@jmc/solid-design-system/src/hooks/useMediaQuery/useMediaQuery";
import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import { CMSRecipe } from "@jwm/types/CMSRecipe";
import React from "react";
import { useTranslation } from "react-i18next";

import style from "../style.module.scss";

export const RelatedRecipes = (props: { pageTitle: string; relatedRecipes: CMSRecipe[] }): JSX.Element => {
    const { jnjFullBranded } = useJnjBranding();
    const { t } = useTranslation();
    const isMobile = useMediaQuery(BreakPoint.lg);

    const { pageTitle, relatedRecipes } = props;

    const recipes =
        relatedRecipes?.map((r, i) => {
            return (
                <RecipeCard
                    key={i}
                    position={(i + 1) as unknown as string}
                    title={r?.title}
                    url={r?.url}
                    specialty={r?.specialty.map((s) => s?.title)}
                    placement={`page:${pageTitle}`}
                    imageData={r?.image}
                    {...r?.general}
                ></RecipeCard>
            );
        }) || [];

    return recipes?.length > 0 ? (
        <>
            <div className={jnjFullBranded ? style.relatedLabel : style.headerLabel}>
                <Typography variant="h2" color="dark" size={"3xl"} font="title" weight={jnjFullBranded ? "400" : "500"}>
                    {t("You might also like...", { ns: "recipe" })}
                </Typography>
            </div>
            <div className={style.relatedRecipes}>
                {(isMobile && relatedRecipes?.length > 1) || (!isMobile && relatedRecipes?.length > 3) ? (
                    <Slider fullWidth={false}>{recipes}</Slider>
                ) : (
                    <CSSGrid
                        container
                        width={jnjFullBranded ? undefined : "20rem"}
                        size={jnjFullBranded ? undefined : "auto"}
                        overview={jnjFullBranded}
                        gap={jnjFullBranded ? 24 : 16}
                    >
                        {recipes}
                    </CSSGrid>
                )}
            </div>
        </>
    ) : null;
};
